import React from 'react';
import { object, string } from 'prop-types';
import { N700 } from '@assets/colors';

export default function IconCompare({ style, color }) {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
      >
        <path
          d="M17 7L7.5 8"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 15H4L7.23077 8L10 15Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 14H14L17.2308 7L20 14Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.96657 15H4.03343C3.86862 16.6667 4.2312 19 7 19C9.7688 19 10.1314 16.6667 9.96657 15Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.9666 14H14.0334C13.8686 15.6667 14.2312 18 17 18C19.7688 18 20.1314 15.6667 19.9666 14Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="12"
          cy="6"
          r="1"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}

IconCompare.propTypes = {
  style: object,
  color: string,
};

IconCompare.defaultProps = {
  style: {},
  color: N700
};
